// extracted by mini-css-extract-plugin
export default {"wrapper":"ReportScreenCanvas_wrapper__FlOVU","image":"ReportScreenCanvas_image__cQBVV"};